import { MessageCircle } from 'lucide-react';

export default function WhatsAppButton() {
  const phoneNumber = '41627248005';
  const message = 'Hallo! Ich interessiere mich für einen Umzug von der Schweiz nach Deutschland.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 right-6 bg-green-700 hover:bg-green-800 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all z-40 group min-w-[48px] min-h-[48px] flex items-center justify-center"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6 group-hover:scale-110 transition-transform" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-slate-900 text-white px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat mit uns auf WhatsApp
      </span>
    </a>
  );
}
